(() => {
  if (customElements.get('fusion-dispatch-estimate')) return;
  class FusionDispatchEstimate extends HTMLElement {
    connectedCallback() {
      this.policies = JSON.parse(this.querySelector('[data-dispatch-variants]').textContent);
      this.message = this.querySelector('[data-dispatch-message]');
      this.legacy = this.querySelector('[data-dispatch-legacy]');
      this.scope = this.closest('.shopify-section') || document;
      this.update = () => {
        if (document.hidden) return;
        const forms = [...this.scope.querySelectorAll('form[action*="/cart/add"]')];
        const inputs = forms.map(form => form.querySelector('[name="id"]')).filter(Boolean);
        const known = inputs.find(input => Object.hasOwn(this.policies, input.value));
        const urlId = new URL(location.href).searchParams.get('variant');
        // Theme form state takes priority; an unmatched/empty selected value hides
        // a previous variant's promise. URL is a fallback for themes without forms.
        const id = known ? known.value : inputs.length ? inputs[0].value : urlId || this.dataset.initialVariant;
        this.selectedId = id;
        if (id && /^\d+$/.test(id) && !Object.hasOwn(this.policies, id)) this.loadVariant(id);
        const policy = this.policies[id];
        const valid = policy?.enabled === true && Number.isInteger(policy.minDays) && Number.isInteger(policy.maxDays)
          && policy.minDays >= 1 && policy.maxDays >= policy.minDays && policy.maxDays <= 3650;
        // Existing custom themes may keep their old product-level message
        // until Fusion publishes this variant. Explicit hide/clear never falls
        // back to that old promise, and unknown selections remain hidden.
        if (this.legacy) this.legacy.hidden = !policy || policy.managed !== false;
        this.message.hidden = !valid;
        this.message.textContent = valid ? `Usually dispatches in ${policy.minDays === policy.maxDays ? policy.minDays : `${policy.minDays}–${policy.maxDays}`} business ${policy.maxDays === 1 ? 'day' : 'days'}` : '';
      };
      document.addEventListener('change', this.update);
      document.addEventListener('variant:change', this.update);
      document.addEventListener('product:variant-change', this.update);
      window.addEventListener('popstate', this.update);
      // Themes differ in variant events; hidden form values may change as a
      // property without an event or attribute mutation. Poll only while visible.
      this.timer = setInterval(this.update, 500);
      this.update();
    }
    async loadVariant(id) {
      if (!this.dataset.sectionId || this.loadingId === id || (this.lastFailedId === id && Date.now() - this.lastFailedAt < 10000)) return;
      this.controller?.abort();
      const controller = new AbortController();
      this.controller = controller;
      this.loadingId = id;
      try {
        // Liquid only includes the first 250 variants. Fetch the selected
        // variant's block from Shopify for larger products, without Fusion.
        const url = new URL(this.dataset.productUrl, location.origin);
        url.searchParams.set('variant', id);
        url.searchParams.set('section_id', this.dataset.sectionId);
        const response = await fetch(url, {signal: controller.signal, credentials: 'same-origin'});
        if (!response.ok) throw new Error('Section unavailable');
        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        const block = [...parsed.querySelectorAll('fusion-dispatch-estimate')].find(node => node.dataset.blockId === this.dataset.blockId);
        const policies = JSON.parse(block.querySelector('[data-dispatch-variants]').textContent);
        if (controller.signal.aborted) return;
        this.policies[id] = policies[id] || {enabled:false,managed:true};
        if (this.selectedId === id) this.update();
      } catch (error) {
        if (error.name !== 'AbortError') { this.lastFailedId=id; this.lastFailedAt=Date.now(); }
      } finally {
        if (this.controller === controller) this.loadingId = null;
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      clearInterval(this.timer);
      document.removeEventListener('change', this.update);
      document.removeEventListener('variant:change', this.update);
      document.removeEventListener('product:variant-change', this.update);
      window.removeEventListener('popstate', this.update);
    }
  }
  customElements.define('fusion-dispatch-estimate', FusionDispatchEstimate);
})();
